import { THighLight } from '../interfaces/news';
import { IQnaMaterial } from '../interfaces/qna';
import { ISearchItem } from '../interfaces/search';

export const decorateSearchItem = (item: IQnaMaterial & THighLight): ISearchItem => {
  const author = item.expertAnswer?.author || item.bestAnswer?.author;

  return {
    type: item.type || 'qna',
    id: item.id,
    alias: item.alias || item.slug,
    title: item.title,
    text: item.lead || item.text,
    publishDate: item.published || item.pubDate,
    ...(item.rubric && { rubric: item.rubric }),
    ...(item.type === 'news' && { tags: item.tags }),
    ...(author && {
      author: {
        id: author.id,
        name: author.name,
        lastName: author.lastName,
      },
    }),
    ...(item.isExternal && item.url && { externalLink: item.url }),
  };
};

export const decorateSearchList = (list: IQnaMaterial[] & THighLight[]): ISearchItem[] => {
  if (!list?.length) return [];
  return list.map((item) => decorateSearchItem(item));
};
